import { createAction, props } from '@ngrx/store';
import { PerUserMfaModel, PerUserMfaState } from './model';

export const fetchGraphPerUserMfaState = createAction(
    '[Graph/AuthRequirements] Load',
    props<{ _tenant: string; ids: string[] }>(),
);

export const fetchGraphPerUserMfaStateSuccess = createAction(
    '[Graph/AuthRequirements] Load Success',
    props<{ _tenant: string; data: PerUserMfaModel[] }>(),
);

export const fetchGraphPerUserMfaStateFailure = createAction(
    '[Graph/AuthRequirements] Load Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updatePerUserMfaState = createAction(
    '[Graph/AuthRequirements] Update perUserMfaState',
    props<{ _tenant: string; userId: string; perUserMfaState: PerUserMfaState }>(),
);

export const updatePerUserMfaStateSuccess = createAction(
    '[Graph/AuthRequirements] Update perUserMfaState Success',
    props<{ _tenant: string; userId: string; perUserMfaState: PerUserMfaState }>(),
);

export const updatePerUserMfaStateFailure = createAction(
    '[Graph/AuthRequirements] Update perUserMfaState Failure',
    props<{ _tenant: string; error: any }>(),
);
